import React from 'react';
import { Bolt, LocalGasStation, Speed, } from '@mui/icons-material';

// Services data for ServicesDetailed component
export const servicesDetailedData = [
    {
        title: 'V-max anhebung',
        description: 'In unserer Tuning Werkstatt in Stuttgart wird die V-Max-Sperre in der Regel zusammen mit dem Tuning aufgehoben, sodass Ihnen keine weiteren Kosten für eine separate Anhebung entstehen.',
        icon: <Bolt sx={{ fontSize: 40, color: 'white' }} />
    },
    {
        title: 'Weniger Verbrauch',
        description: 'Chiptuning in Pforzheim bietet Ihnen zusammen mit der Leistungssteigerung auch ein Ecotuning, mit dem Sie bis zu 1,5 l an Verbrauch sparen.',
        icon: <LocalGasStation sx={{ fontSize: 40, color: 'white' }} />
    },
    {
        title: 'Drosselung',
        description: 'Wenn Sie einen Fuhrpark besitzen, machen wir Ihnen als Tuning Werkstatt in Stuttgart ein Angebot für Ihr komplettes Logistik- oder Taxiunternehmen.',
        icon: <Speed sx={{ fontSize: 40, color: 'white' }} />
    }
];